// TEAMS Website - Animation Constants
// These should match the SCSS variables in _variables.scss

export const ANIMATION_TIMING = {
  // Transition speeds (matching SCSS $transition-* variables)
  SCROLL_REVEAL: 800, // $transition-scrollreveal: 0.8s
  HOVER: 500,         // $transition-hover: 0.5s  
  HOVER_OUT: 500,     // $transition-hover-out: 0.5s
  
  // Animation timing (matching SCSS variables)
  STAGGER_DELAY: 500, // $stagger-delay: 500ms
};

